<template>
  <div class="register-popup">
    <div>
        <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
            <el-form-item  prop="email">
                <el-input placeholder="請填寫信箱" v-model="registerForm.email"></el-input>
            </el-form-item>
            <el-form-item  prop="password">
                <el-input placeholder="請輸入密碼" type="password" v-model="registerForm.password"></el-input>
            </el-form-item>
            <el-form-item  prop="passwordCheck">
                <el-input placeholder="再次輸入密碼" type="password" v-model="registerForm.passwordCheck"></el-input>
            </el-form-item>
            <el-form-item  prop="userName">
                <el-input placeholder="請填寫暱稱" v-model="registerForm.userName"></el-input>
            </el-form-item>
            <el-checkbox v-model="checked" class="authorize">我同意<span>隱私權政策</span>及<span>服務協議</span></el-checkbox>
            <el-form-item>
              <div class="btn-group">
                 <el-button type="primary" @click="doRegister()">註冊</el-button>
                <el-button @click="onClose">取消</el-button>
              </div>
             
          </el-form-item>
        </el-form>
    </div>
  </div>

</template>

<script>
import { mapState,mapActions } from 'vuex'
import '../../utils/jsencrypt'
export default {
    props: {
        showDialog: {
            type: Boolean,
            require: true
        },
    },
    data(){
      var validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('請輸入email'));
        } else if (value.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/)== -1) {
          callback(new Error('email格式不正確'));
        } else {
          callback();
        }
      };
      var validatePassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length<6 || value.length>10) {
          callback(new Error('請輸入6-10位的密碼'));
        } else {
          callback();
        }
      };
      var validatePasswordCheck = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.registerForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validateuserName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请輸入用戶名稱'));
        } else if (value.length<3 || value.length>8) {
          callback(new Error('請輸入3-8字的用戶名'));
        } else {
          callback();
        }
      };
      return{
        // 是否註冊成功
        registerForm:{
          email:"",
          password:"",
          passwordCheck:"",
          userName:"",
        },
        checked:false,
        registerRules: {
          email: [
            { validator: validateEmail, trigger: 'blur' }
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ],
          passwordCheck: [
            { validator: validatePasswordCheck, trigger: 'blur' }
          ],
          userName: [
            { validator: validateuserName, trigger: 'blur' }
          ],
        }
      }
    },
    mounted(){
        
    },
    computed:{
      ...mapState({
            userImg: state => state.user.userImg,
            userName: state => state.user.userName,
        }),
        isLogin(){
            return this.$store.state.user.userAccount?true:false
        }
    },
    watch:{
    },
    methods:{
        ...mapActions('user', ['userRegister','userLogin']),
        async doRegister(){
          let data = {
            email : this.registerForm.email,
            password : this.registerForm.password,
            userName : this.registerForm.userName
          }
          await this.userRegister(data)
          this.$emit('registerSuccess',data)
        },
      onClose(){
        if (this.registerSuccess){
          this.userRegister(this.registerForm)
        }
        this.$hideLoginPopup()
      }
    }
    
}
</script>

<style lang='scss' scoped>
.register-popup{
  .authorize {
    font-size: 12px;
    color: $textColor;
    span {
      color: $mainColor;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .btn-group {
    display: flex;
    flex-direction: column;
    button {
      margin: 10px 0;
    }
  }
}
</style>